module.exports = __webpack_public_path__ + "static/media/1001360TL.a10b4baf.jpg";